import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {makeNavbarBackgroundStyles} from 'nav/navbar/NavBarColor';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import ClickOutWrapper from 'ui-library/ClickOutWrapper';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import * as SidepanelActions from '../sidepanel/SidepanelActions';
import {getIconStyles, navBarIconStyles} from './NavBarIcon';

export interface CreateIconProps {
  createMenu: React.ReactNode;
  isCreateMenuOpen: boolean;
}

class CreateIcon extends React.Component<CreateIconProps> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleToggleCreateMenu = () => {
    if (this.props.isCreateMenuOpen) {
      SidepanelActions.closeCreateMenu();
    } else {
      SidepanelActions.openCreateMenu();
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleCloseCreateMenu = () => {
    if (this.props.isCreateMenuOpen) {
      SidepanelActions.closeCreateMenu();
    }
  };

  render(): JSX.Element {
    const itemStyles = getIconStyles(this.props.isCreateMenuOpen);
    return (
      <ClickOutWrapper shouldCloseOnInsideClick={false} onClickOut={this._handleCloseCreateMenu}>
        <Tooltip
          container="body"
          disabled={this.props.isCreateMenuOpen}
          placement={TooltipPlacement.RIGHT}
          title="Create"
        >
          <div
            className={classNames(css(itemStyles), this.props.isCreateMenuOpen && 'open')}
            style={makeNavbarBackgroundStyles(false)}
          >
            <div
              className={classNames(css(navBarIconStyles.inner), '_test-createIcon-inner')}
              onClick={this._handleToggleCreateMenu}
            >
              <BenchlingIcon icon="compose" className={css(navBarIconStyles.icon)} />
            </div>
            <div
              onClick={this._handleCloseCreateMenu}
              className={classNames(this.props.isCreateMenuOpen && 'open')}
            >
              {this.props.createMenu}
            </div>
          </div>
        </Tooltip>
      </ClickOutWrapper>
    );
  }
}

export default CreateIcon;
